import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/mental-health-education', label: 'Mental Health Education' },
    { path: '/about', label: 'About' },
    { path: '/resources', label: 'Resources' },
    { path: '/faqs', label: 'FAQs' },
    { path: '/crisis-resources', label: 'Crisis Resources' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#2c3e50] shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity mr-8">
            <div className="h-12 w-12 bg-white rounded-full flex items-center justify-center p-2">
              <img
                src="https://customer-assets.emergentagent.com/job_harmony-behavioral/artifacts/rov8cr92_HHW_icon.jpg"
                alt="Harmony Behavioral & Psychiatric Health"
                className="h-full w-full object-contain"
              />
            </div>
            <div>
              <h1 className="text-base md:text-lg font-bold text-white leading-tight">
                Harmony Behavioral &<br className="md:hidden" /> Psychiatric Health
              </h1>
              <p className="text-xs text-[#a8b5a0] font-medium">Evidence informed care</p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-white text-sm font-medium hover:text-[#c9b17a] transition-colors relative group ${
                  location.pathname === link.path ? 'text-[#c9b17a]' : ''
                }`}
              >
                {link.label}
                <span
                  className={`absolute -bottom-1 left-0 h-0.5 bg-[#c9b17a] transition-all ${
                    location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                />
              </Link>
            ))}
            <Link to="/book-appointment">
              <Button className="bg-[#c9b17a] hover:bg-[#b89d66] text-white font-semibold shadow-md rounded-lg">
                Book Now
              </Button>
            </Link>
          </nav>

          <button className="lg:hidden p-2 text-white hover:text-[#c9b17a] transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-[#d4cec5] mt-2 pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 text-white font-medium hover:text-[#c9b17a] transition-colors ${
                  location.pathname === link.path ? 'text-[#c9b17a]' : ''
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/book-appointment" className="block mt-2" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-[#c9b17a] hover:bg-[#b89d66] text-white font-semibold rounded-lg">
                Book Now
              </Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;